module.exports = __webpack_public_path__ + "img/alejandro_chani.0dadb098.png";